var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentStatusCritical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.6 4.935L4.479.6h7.042L15.4 4.935v6.13L11.521 15.4H4.48L.6 11.065v-6.13z",
    fill: "#DB3737",
    fillOpacity: 0.1,
    stroke: "#DB3737",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4h2l-.5 5h-1L7 4z",
    fill: "#DB3737"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    fill: "#DB3737"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNiA0LjkzNTEyTDQuNDc4NzkgMC42SDExLjUyMTJMMTUuNCA0LjkzNTEyVjExLjA2NDlMMTEuNTIxMiAxNS40SDQuNDc4NzlMMC42IDExLjA2NDlWNC45MzUxMloiIGZpbGw9IiNEQjM3MzciIGZpbGwtb3BhY2l0eT0iMC4xIiBzdHJva2U9IiNEQjM3MzciIHN0cm9rZS13aWR0aD0iMS4yIi8+CjxwYXRoIGQ9Ik03IDRIOUw4LjUgOUg3LjVMNyA0WiIgZmlsbD0iI0RCMzczNyIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iMTEiIHI9IjEiIGZpbGw9IiNEQjM3MzciLz4KPC9zdmc+Cg==";
export { SvgAgentStatusCritical as ReactComponent };